import Header from "../header/header";
import LeftMenuLogo from "../widgets/leftMenuLogo";
import MenuButton from "../widgets/menuButton";
import DashboardCustomizeOutlinedIcon from "@mui/icons-material/DashboardCustomizeOutlined";
import SettingsIcon from "@mui/icons-material/Settings";
import FoundationIcon from "@mui/icons-material/Foundation";
import "./home.css";
import { useEffect, useState } from "react";
import Dashboard from "./dashboard";
import InventoryOutlinedIcon from "@mui/icons-material/InventoryOutlined";
import ContactSupportIcon from "@mui/icons-material/ContactSupport";
import { Route, Routes, useNavigate } from "react-router-dom";
import { deleteToken } from "../../utils/util";
import { MOBILE_THRESHOLD } from "../../constants/constants";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import GroupIcon from "@mui/icons-material/Group";
import DeliveryDiningIcon from "@mui/icons-material/DeliveryDining";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import Customers from "../customers/customers";
import Orders from "../orders/orders";
import Banners from "../banners/banners";
import Notifications from "../notifications/notifications";
import Transactions from "../transactions/transactions";
import TimelineIcon from "@mui/icons-material/Timeline";
import Timeline from "../timelines/timeline";
import UserDetails from "../orders/UserDetails";
import CocoonStock from "../customers/CocoonStock";
import SettingsPage from "../settings/SettingsPage";
import Support from "../support/support";
import PasswordReset from "./PasswordReset";
import StoreIcon from "@mui/icons-material/Store";
import PaymentDetailsForm from "../settings/PaymentDetailsForm";
import ToolsMarket from "../tools/ToolsMarket";
import SericultureToolsPage from "../tools/AddTools";
import ToolsPage from "../tools/ToolsPage";
import ViewProduct from "../tools/ViewProduct";
import AddCategoryForm from "../tools/AddCategoryForm";
import CategoriesList from "../tools/CategoriesList";
import ToolsSettingsPage from "../tools/ToolsSettingsPage";
import ToolsOrders from "../tools/ToolsOrders";
import ToolsOrderDetails from "../tools/ToolsOrderDetails";
import Stocks from "../stocks/Stocks";
const Home = (props) => {
  const loc = document.location.href.replace(/\/+$/, "");
  const keysUrl = loc.split("/");
  let pos = "";
  if (keysUrl.length > 3) {
    pos = keysUrl[4]?.split("?")[0]?.split("#")[0];
  }
  console.log(pos);
  const navigate = useNavigate();
  const [collapse, setCollapse] = useState(false);

  const [windowSize, setWindowSize] = useState(getWindowSize());
  useEffect(() => {
    if (windowSize.innerWidth < MOBILE_THRESHOLD) {
      setCollapse(true);
    }
    function handleWindowResize() {
      setWindowSize(getWindowSize());
    }
    window.addEventListener("resize", handleWindowResize);
    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);
  function getWindowSize() {
    const { innerWidth, innerHeight } = window;
    return { innerWidth, innerHeight };
  }

  const logout = () => {
    deleteToken();
    navigate("/login");
  };
  return (
    <div className="home">
      <Header
        logout={logout}
        windowSize={windowSize}
        title={pos}
        collapse={collapse}
        setCollapse={setCollapse}
      />
      <div className={collapse ? "left_menu_box collapse" : "left_menu_box"}>
        {windowSize.innerWidth < MOBILE_THRESHOLD && !collapse && (
          <IconButton
            onClick={(e) => setCollapse(true)}
            sx={{ position: "absolute", top: "12px", right: "8px" }}
            size="small"
          >
            <CloseIcon />
          </IconButton>
        )}
        <LeftMenuLogo collapse={collapse} />
        <div
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            boxShadow: "5px 0 5px -5px rgb(176 210 238)",
            overflowY: "auto",
          }}
        >
          <MenuButton
            to="dashboard"
            collapse={collapse}
            text="My Dashboard"
            MenuIcon={DashboardCustomizeOutlinedIcon}
            active={pos === "dashboard"}
          />
          <MenuButton
            to="users"
            collapse={collapse}
            text="Users"
            MenuIcon={GroupIcon}
            active={pos === "users"}
          />
          <MenuButton
            to="orders"
            collapse={collapse}
            text="Orders"
            MenuIcon={AddShoppingCartIcon}
            active={pos === "orders"}
          />
          <MenuButton
            to="transactions"
            collapse={collapse}
            text="Payments"
            MenuIcon={DeliveryDiningIcon}
            active={pos === "transactions"}
          />
          <MenuButton
            to="add-payment-details"
            collapse={collapse}
            text="Account Details"
            MenuIcon={TimelineIcon}
            active={pos === "add-payment-details"}
          />
          <MenuButton
            to="cocoon-stock"
            collapse={collapse}
            text="Cocoon Stock"
            MenuIcon={FoundationIcon}
            active={pos === "cocoon-stock"}
          />
          <MenuButton
            to="stocks"
            collapse={collapse}
            text="Stocks"
            MenuIcon={InventoryOutlinedIcon}
            active={pos === "cocoon-stock"}
          />
          <MenuButton
            to="tools-market"
            collapse={collapse}
            text="Tools Market"
            MenuIcon={StoreIcon}
            active={pos === "tools-market"}
          />
          <MenuButton
            to="notifications"
            collapse={collapse}
            text="Notifications"
            MenuIcon={NotificationsNoneIcon}
            active={pos === "notifications"}
          />
          <MenuButton
            to="user-support"
            collapse={collapse}
            text="User Support"
            MenuIcon={ContactSupportIcon}
            active={pos === "user-support"}
          />
          <MenuButton
            to="settings"
            collapse={collapse}
            text="Settings"
            MenuIcon={SettingsIcon}
            active={pos === "settings"}
          />

          {/* <MenuButton onClick={logout} collapse={collapse} text="Logout" MenuIcon = {LogoutIcon} /> */}
        </div>
      </div>
      <div
        style={{
          marginLeft: collapse
            ? 70
            : windowSize.innerWidth < MOBILE_THRESHOLD
            ? 70
            : 200,
          padding: 16,
        }}
      >
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="users" element={<Customers />} />
          <Route path="users/:userId" element={<UserDetails />} />
          <Route path="orders/*" element={<Orders />} />
          <Route path="add-payment-details" element={<PaymentDetailsForm />} />
          <Route path="transactions/*" element={<Transactions />} />
          <Route path="timelines" element={<Timeline />} />
          <Route path="tools-market" element={<ToolsMarket />} />
          <Route path="add-tool" element={<SericultureToolsPage />} />
          <Route path="add-form" element={<AddCategoryForm />} />
          <Route path="categories" element={<CategoriesList />} />
          <Route path=":id/edit-tool" element={<SericultureToolsPage />} />
          <Route path=":id/view-tool" element={<ViewProduct />} />
          <Route path="tools" element={<ToolsPage />} />
          <Route path="stocks" element={<Stocks />} />
          <Route path="cocoon-stock" element={<CocoonStock />} />
          <Route path="password-reset" element={<PasswordReset />} />
          <Route path="banners" element={<Banners />} />
          <Route path="user-support" element={<Support />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="tools-settings" element={<ToolsSettingsPage />} />
          <Route path="tools-orders" element={<ToolsOrders />} />
          <Route path="tools-order/:id" element={<ToolsOrderDetails />} />
          <Route path="notifications" element={<Notifications />} />
        </Routes>
      </div>
    </div>
  );
};
export default Home;
